<template>
    <div :id="this.id"
         class="sitebuilder-element-container"
         element="ButtonComponent"
         :data-hide-desktop="!this.internal_config.showDesktop"
         :data-hide-mobile="!this.internal_config.showMobile"
         :data-tag="dataTag()"
         :style="style()">

        <div v-bind:style="{height : height,
                                  width : width,
                                  border : border,
                                  'border-radius': radius,
                                  backgroundColor: backgroundColor,
                                    backgroundImage: backgroundImage,
                                    backgroundSize: backgroundSize,
                                    backgroundPosition: backgroundPosition,
                                    backgroundOrigin: backgroundOrigin,
                                    backgroundRepeat: backgroundRepeat,
                                  'box-shadow': boxShadow,
                                  'cursor': 'pointer'
                                  }" class="bt-sb desktop-element">

            <a class="bt-text-area" v-if="htmlLink()" :href="hrefLink('href')" :target="hrefLink('target')"
               v-bind:style="{ height : height, width : width}">
                <span class="btn sb-text" :style="textStyle()">{{internal_config.text}}</span>
                <br :v-show="this.internal_config.subtext != ''"/>
                <small class="btn sb-sub-text" v-show="this.internal_config.subtext != ''"
                       :style="subTextStyle()">{{internal_config.subtext}}</small>
            </a>
            <a class="bt-text-area" v-if="!htmlLink()" @click="linkAction()"
               v-bind:style="{ height : height, width : width}">
                <span class="btn sb-text" :style="textStyle()">{{internal_config.text}}</span>
                <br :v-show="this.internal_config.subtext != ''"/>
                <small class="btn sb-sub-text" v-show="this.internal_config.subtext != ''"
                       :style="subTextStyle()">{{internal_config.subtext}}</small>
            </a>
        </div>
        <div v-bind:style="{height : height,
                                  width : width,
                                  border : border,
                                  'border-radius': radius,
                                  backgroundColor: backgroundColor,
                                    backgroundImage: backgroundImage,
                                    backgroundSize: backgroundSize,
                                    backgroundPosition: backgroundPosition,
                                    backgroundOrigin: backgroundOrigin,
                                    backgroundRepeat: backgroundRepeat,
                                  'box-shadow': boxShadow,
                                  'cursor': 'pointer'
                                  }" class="bt-sb mobile-element">

            <a class="bt-text-area" v-if="htmlLink()" :href="hrefLink('href')" :target="hrefLink('target')"
               v-bind:style="{ height : height, width : width}">
                <span class="btn sb-text" :style="textStyleMobile()">{{internal_config.text}}</span>
                <br :v-show="this.internal_config.subtext != ''"/>
                <small class="btn sb-sub-text" v-show="this.internal_config.subtext != ''"
                       :style="subTextStyle()">{{internal_config.subtext}}</small>
            </a>
            <a class="bt-text-area" v-if="!htmlLink()" @click="linkAction()"
               v-bind:style="{ height : height, width : width}">
                <span class="btn sb-text" :style="textStyleMobile()">{{internal_config.text}}</span>
                <br :v-show="this.internal_config.subtext != ''"/>
                <small class="btn sb-sub-text" v-show="this.internal_config.subtext != ''"
                       :style="subTextStyle()">{{internal_config.subtext}}</small>
            </a>
        </div>


    </div>
</template>

<script>

	import Data from './Model';
	import Resources from './Resources.vue';
	import {SweetModal} from 'sweet-modal-vue'

	export default {
		name: 'ButtonComponent',
		props: ['config', 'id', 'preview'],
		components: {
			Data,
			Resources,
			SweetModal
		},
		computed: {
			width() {
				return this.internal_config.width;
			},
			height() {
				return this.internal_config.height;
			},
			border() {
				return this.internal_config.border;
			},
			boxShadow() {
				return this.internal_config.boxShadow;
			},
			radius() {
				return this.internal_config.borderRadius;
			},
			backgroundColor() {

				if (/MSIE 10/i.test(navigator.userAgent)) {
					// This is internet explorer 10
					return this.internal_config.backgroundColor.substr(0, 7)
				}

				if (/MSIE 9/i.test(navigator.userAgent) || /rv:11.0/i.test(navigator.userAgent)) {
					// This is internet explorer 9 or 11
					return this.internal_config.backgroundColor.substr(0, 7)
				}

				if (/Edge\/\d./i.test(navigator.userAgent)) {
					// This is Microsoft Edge
					return this.internal_config.backgroundColor.substr(0, 7)
				}

				return this.internal_config.backgroundColor;
			},
			backgroundImage() {
				if (this.internal_config.backgroundImage !== 'none' && typeof this.internal_config.backgroundImage !== 'undefined') {
					return 'url("' + this.internal_config.backgroundImage + '")';
				}
				return '';
			},
			backgroundPosition() {
				if (this.internal_config.backgroundImage !== 'none' && typeof this.internal_config.backgroundImage !== 'undefined') {
					return this.internal_config.backgroundPosition
				}
				return '';
			},
			backgroundOrigin() {
				if (this.internal_config.backgroundImage !== 'none' && typeof this.internal_config.backgroundImage !== 'undefined') {
					return this.internal_config.backgroundOrigin
				}
				return '';
			},
			backgroundRepeat() {
				if (this.internal_config.backgroundImage !== 'none' && typeof this.internal_config.backgroundImage !== 'undefined') {
					return this.internal_config.backgroundRepeat
				}
				return '';
			},
			backgroundSize() {
				if (this.internal_config.backgroundImage !== 'none' && typeof this.internal_config.backgroundImage !== 'undefined') {
					return this.internal_config.backgroundSize
				}
				return '';
			},
		},
		data() {
			return Data.data();
		},
		methods: {

			htmlLink() {
				if (this.internal_config.link.type === 'web' || this.internal_config.link.type === 'page') {
					return true
				} else {
					return false;
				}
			},
			htmlVideo() {
				if (this.internal_config.link.type === 'video' && this.internal_config.link.value !== '') {
					console.log(this.internal_config.link.value);
					// return this.internal_config.link.value;
				}
			},

			getValidUrl(url = "") {
				let newUrl = window.decodeURIComponent(url);
				newUrl = newUrl.trim().replace(/\s/g, "");

				if (/^(:\/\/)/.test(newUrl)) {
					return `http${newUrl}`;
				}
				if (!/^(f|ht)tps?:\/\//i.test(newUrl)) {
					return `http://${newUrl}`;
				}

				return newUrl;
			},

			hrefLink(key) {
				let obj = {};

				if (this.internal_config.link.type === 'web') {
					obj.href = this.getValidUrl(this.internal_config.link.value)

				} else if (this.internal_config.link.type === 'page') {

					pagesConfig.forEach(page => {
						if (this.internal_config.link.valueID == page.id) {
							obj.href = '/' + page.url;
						}
					})

				} else {
					obj.href = '#';
				}

				obj.target = this.internal_config.link.target;

				return obj[key];
			},
			linkAction: function () {

				console.log(this.internal_config.link);
				this.$root.$emit('linkAction', this.internal_config.link);

			},
			buildIcon: function () {

				$(this.$el).find('i').detach();

				if (this.internal_config.icon !== '') {
					if (this.internal_config.iconPosition === 'left') {
						$('<i>').addClass('mdi ' + this.internal_config.icon).prependTo($(this.$el).find('.sb-text').get(0));
						$('<i>').addClass('mdi ' + this.internal_config.icon).prependTo($(this.$el).find('.sb-text').get(1));
					}
					if (this.internal_config.iconPosition === 'right') {
						$('<i>').addClass('mdi ' + this.internal_config.icon).appendTo($(this.$el).find('.sb-text').get(0));
						$('<i>').addClass('mdi ' + this.internal_config.icon).appendTo($(this.$el).find('.sb-text').get(1));
					}
				}
			}, build(config) {
				this.internal_config = config;
				this.buildIcon();
			},
			textStyle() {

				let colorFont = this.internal_config.textStyle.color;
				if (/MSIE 10/i.test(navigator.userAgent)) {
					// This is internet explorer 10
					colorFont = this.internal_config.textStyle.color.substr(0, 7)
				}

				if (/MSIE 9/i.test(navigator.userAgent) || /rv:11.0/i.test(navigator.userAgent)) {
					// This is internet explorer 9 or 11
					colorFont = this.internal_config.textStyle.color.substr(0, 7)
				}

				if (/Edge\/\d./i.test(navigator.userAgent)) {
					// This is Microsoft Edge
					colorFont = this.internal_config.textStyle.color.substr(0, 7)
				}

				return `font-family:  ${this.internal_config.textStyle.family};
                 font-size: ${this.internal_config.textStyle.size};
                 text-align: ${this.internal_config.textStyle.align};
                 font-weight: ${this.internal_config.textStyle.weight};
                 font-style: ${this.internal_config.textStyle.style};
                 color: ${colorFont}`;
			},
			textStyleMobile() {

				let colorFont = this.internal_config.textStyle.color;
				if (/MSIE 10/i.test(navigator.userAgent)) {
					// This is internet explorer 10
					colorFont = this.internal_config.textStyle.color.substr(0, 7)
				}

				if (/MSIE 9/i.test(navigator.userAgent) || /rv:11.0/i.test(navigator.userAgent)) {
					// This is internet explorer 9 or 11
					colorFont = this.internal_config.textStyle.color.substr(0, 7)
				}

				if (/Edge\/\d./i.test(navigator.userAgent)) {
					// This is Microsoft Edge
					colorFont = this.internal_config.textStyle.color.substr(0, 7)
				}

				return `font-family:  ${this.internal_config.textStyle.family};
                 font-size: ${this.internal_config.textStyle.sizeMobile};
                 text-align: ${this.internal_config.textStyle.align};
                 font-weight: ${this.internal_config.textStyle.weight};
                 font-style: ${this.internal_config.textStyle.style};
                 color: ${colorFont}`;
			},
			subTextStyle() {

				let colorFont = this.internal_config.subTextStyle.color;
				if (/MSIE 10/i.test(navigator.userAgent)) {
					// This is internet explorer 10
					colorFont = this.internal_config.subTextStyle.color.substr(0, 7)
				}

				if (/MSIE 9/i.test(navigator.userAgent) || /rv:11.0/i.test(navigator.userAgent)) {
					// This is internet explorer 9 or 11
					colorFont = this.internal_config.subTextStyle.color.substr(0, 7)
				}

				if (/Edge\/\d./i.test(navigator.userAgent)) {
					// This is Microsoft Edge
					colorFont = this.internal_config.subTextStyle.color.substr(0, 7)
				}

				return `font-family:  ${this.internal_config.subTextStyle.family};
                 font-size: ${this.internal_config.subTextStyle.size};
                 text-align: ${this.internal_config.subTextStyle.align};
                 font-weight: ${this.internal_config.subTextStyle.weight};
                 font-style: ${this.internal_config.subTextStyle.style};
                 color: ${colorFont}`;
			},
			style() {
				return `left:  ${this.internal_config.left};
				        padding-top: ${this.internal_config.paddingTop};
                     z-index: ${this.internal_config.zIndex};
                padding-left: ${this.internal_config.paddingLeft};
                padding-right: ${this.internal_config.paddingRight};
                padding-bottom: ${this.internal_config.paddingBottom};
                top: ${this.internal_config.top}`;
			},
			styleResize() {
				return `{width: ${this.internal_config.width}, height:  ${this.internal_config.height}}`;
			},
			handler: function (e) {
				this.$root.$emit('focusElement', this);
				this.$root.$emit('handlerElement', this);
				e.stopPropagation();
				e.preventDefault();
			},

			dataTag() {
				if (this.internal_config.tag) {
					return this.internal_config.tag;
				}
				return '';
			},
		},
		mounted() {
			this.build(this.$props.config);

			this.internal_config = window.mergeRecursive(this.props, this.$props.config);

			this.$root.$emit('applyAnimation', this, 'sitebuilder-element-container');

			this.$nextTick(() => {
				let backgroundColorHover = this.internal_config.backgroundColorHover;
				let textColorHover = this.internal_config.textColorHover;
				if (/MSIE 10/i.test(navigator.userAgent)) {
					// This is internet explorer 10
					backgroundColorHover = this.internal_config.backgroundColorHover.substr(0, 7)
					textColorHover = this.internal_config.textColorHover.substr(0, 7)
				}

				if (/MSIE 9/i.test(navigator.userAgent) || /rv:11.0/i.test(navigator.userAgent)) {
					// This is internet explorer 9 or 11
					textColorHover = this.internal_config.textColorHover.substr(0, 7)
					backgroundColorHover = this.internal_config.backgroundColorHover.substr(0, 7)
				}

				if (/Edge\/\d./i.test(navigator.userAgent)) {
					// This is Microsoft Edge
					textColorHover = this.internal_config.textColorHover.substr(0, 7)
					backgroundColorHover = this.internal_config.backgroundColorHover.substr(0, 7)
				}

				this.$el.addEventListener('mouseover', function () {
					document.body.style.setProperty('--button-background-color--hover', backgroundColorHover);
					document.body.style.setProperty('--button-text-color--hover', textColorHover);
					console.log(textColorHover);
				});
			})
		}
	}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
    .vdr, .bt-sb {
        /*height: auto !important;*/
        display: inline-table;
    }

    .bt-text-area {
        /*display: grid;*/
        /*height: auto !important;*/

        .btn {
            padding: 0 !important;
        }

    }
</style>
<style lang="scss">

    @media (max-width: 800px) {
        .bt-sb {
            max-width: 300px !important;
            width: 100% !important;
        }
        .bt-text-area {
            display: inline;
            margin: 0 auto;
        }
    }

    [data-device="mobile"] .bt-text-area {
        max-width: 300px !important;
        width: 300px !important;
    }

    .bt-sb {
        margin: 0 auto;
    }

    @media (max-width: 980px) {
        [element="ButtonComponent"] {
            text-align: center !important;
        }
    }

    .bt-sb:hover {
        cursor: pointer;
        background-color: var(--button-background-color--hover) !important;
        color: var(--button-text-color--hover) !important;
        -webkit-text-fill-color: var(--button-text-color--hover) !important;
    }

    .bt-text-area {
        display: table-cell;
        vertical-align: middle;

        .sb-sub-text,
        .sb-text {
            width: 100%;
        }

        .top,
        .bottom {
            width: 100%;
            display: block;
            text-align: center;
        }
    }


</style>
